import { render } from "./ConsolidatedBudgetList.vue?vue&type=template&id=6bc020f4&scoped=true"
import script from "./ConsolidatedBudgetList.vue?vue&type=script&lang=js"
export * from "./ConsolidatedBudgetList.vue?vue&type=script&lang=js"

import "./ConsolidatedBudgetList.vue?vue&type=style&index=0&id=6bc020f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc020f4"]])

export default __exports__